const currentCompanyActionTypes = {
  SET_CURRENT_COMPANY: "SET_CURRENT_COMPANY",
  CLEAR_CURRENT_COMPANY: "CLEAR_CURRENT_COMPANY",
  GET_CURRENT_COMPANY: "GET_CURRENT_COMPANY",
  UPDATE_CURRENT_COMPANY: "UPDATE_CURRENT_COMPANY",
  INIT_CURRENT_COMPANY: "INIT_CURRENT_COMPANY",
};

export default currentCompanyActionTypes;
